"use strict";

exports.__esModule = true;
exports.VideoQueue = void 0;

var VideoQueue =
/*#__PURE__*/
function () {
  function VideoQueue() {
    this.que = [];
    this.dummyVideo = {
      idx: -1,
      isVisible: function isVisible() {
        return false;
      }
    };
    this.video = this.dummyVideo;
  }

  var _proto = VideoQueue.prototype;

  _proto.current = function current() {
    return this.video.idx;
  };

  _proto.isCurrentVideoVisible = function isCurrentVideoVisible() {
    return this.video.isVisible();
  };

  _proto.next = function next() {
    if (this.que.length === 0) {
      return null;
    }

    var i = this.que.indexOf(this.video);
    var nextVideo = this.nextVisibleVideo(i + 1);
    this.video = nextVideo;
    return this.video.idx;
  };

  _proto.nextVisibleVideo = function nextVisibleVideo(j) {
    var len = this.que.length;
    var queIndex;

    for (var i = 0; i < len; i++) {
      queIndex = (i + j) % len;

      if (this.que[queIndex].isVisible()) {
        break;
      }
    }

    return this.que[queIndex] && this.que[queIndex].isVisible() ? this.que[queIndex] : this.dummyVideo;
  };

  _proto.isEmpty = function isEmpty() {
    return this.que.length === 0;
  };

  _proto.addItem = function addItem(item) {
    if (this.isEmpty()) {
      this.video = item;
    }

    this.que.push(item);
  };

  _proto.removeItem = function removeItem(id) {
    this.que = this.que.filter(function (element) {
      return element.idx !== id;
    });

    if (this.isEmpty()) {
      this.video = this.dummyVideo;
    }

    this.video = this.nextVisibleVideo(0);
  };

  return VideoQueue;
}();

exports.VideoQueue = VideoQueue;